
const $header = $('.js-header');
const $search = $('.js-search');

/**
 * Change Header on scroll.
 *
 * @return {Void}
 */

$(window).on('scroll', function(evt) {
	evt.preventDefault();
	triggerHeader();
});

/**
 * Toggle search state.
 *
 * @return {Void}
 */
$search.on('click', 'label', function(evt) {
	evt.preventDefault();

	$search.toggleClass('is-expanded');
	triggerHeader();
	return;
});

/**
 * Check scrollPos ,search state, nav state and change header.
 *
 * @return {Void}
 */

const triggerHeader = () => {
	const scrollPos = $(window).scrollTop();
	const headerIsExpanded = $search.hasClass('is-expanded');
	const navIsActive = $('.js-nav').hasClass('is-active');

	const conditions = scrollPos > 0 || headerIsExpanded || navIsActive;

	if (conditions) {
		$header.addClass('is-active');
		return;
	}

	$header.removeClass('is-active');
}
